var _excluded = ["children", "className", "color", "edge", "shape", "size", "variant"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import clsx from 'clsx';
import { alpha, Button, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Root = styled(Button, {
  name: 'MnrlIconButton',
  slot: 'root',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.root];
  }
})(function (_ref) {
  var _ref$ownerState = _ref.ownerState,
      color = _ref$ownerState.color,
      edge = _ref$ownerState.edge,
      shape = _ref$ownerState.shape,
      size = _ref$ownerState.size,
      variant = _ref$ownerState.variant,
      theme = _ref.theme;
  return _extends({
    marginBlock: undefined,
    // Override value from Mineral Button
    minWidth: 0,
    padding: parseInt(theme.spacing(1)) * (size === 'small' ? 0.5 : size === 'medium' ? 0.75 : 1)
  }, color === 'default' && {
    color: theme.palette.neutral.main,
    borderColor: alpha(theme.palette.neutral.main, 0.5),
    // Matches button
    '&:hover': {
      borderColor: 'currentColor'
    }
  }, edge === 'start' && {
    marginLeft: parseInt(theme.spacing(-1)) / (size === 'small' ? 2 : 1)
  }, edge === 'end' && {
    marginRight: parseInt(theme.spacing(-1)) / (size === 'small' ? 2 : 1)
  }, shape === 'circle' && {
    borderRadius: '50%'
  }, variant === 'outlined' && {
    padding: parseInt(theme.spacing(1)) * (size === 'small' ? 0.5 : size === 'medium' ? 0.75 : 1) - 1
  });
});
export var IconButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'default' : _ref2$color,
      edge = _ref2.edge,
      _ref2$shape = _ref2.shape,
      shape = _ref2$shape === void 0 ? 'circle' : _ref2$shape,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'text' : _ref2$variant,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  if (! /*#__PURE__*/React.isValidElement(children)) {
    console.warn('IconButton only accepts one child, which must be an SvgIcon');
    return null;
  }

  var ownerState = {
    color: color,
    edge: edge,
    shape: shape,
    size: size,
    variant: variant
  };
  return /*#__PURE__*/_jsx(Root, _extends({
    className: clsx('MnrlIconButton-root', className),
    color: color === 'default' ? 'inherit' : color,
    size: size,
    variant: variant,
    ownerState: ownerState
  }, restProps, {
    ref: ref,
    children: children
  }));
});